import {
  initialValues,
  getInitialLaceyAct,
  getInitialFDAFOO,
  merchandiseDuty,
  getNewPGAItem,
  getInitialTSCA,
  getInitialFDA,
  merchandiseLineItem,
  getInitialNHTSA,
  getFDAFOO_AOC,
  getFDAFOO_PQ,
  getFDAFOO_SOURCE_TYPE,
  invoiceItemData,
  getAPHAVS_NAMEANDCODE,
  getAPHAVS_COMMODITY,
  getAPHAVS_SOURCE_TYPE,
  getAPHAVS_NAMEANDCODE_COMPONENT,
  getAPHAVS_NAMEANDCODE_PRODUCT,
  getAPHAVS_COMMODITY_COMPONENT,
  getAPHAVS_COMMODITY_PRODUCT,
  getAPHAVS_SOURCE_TYPE_COMPONENT,
  getAPHAVS_SOURCE_TYPE_PRODUCT,
  getAMS_OR2_LPCOTRANSACTION_Values,
  getSIMPLE_LPCO_VALUES,
  getAMS_OR2_LOTNUMBER_Values,
  getFDADRU_CONSTITUENT_ELEMENT,
  getATFATF_LICENSE_Values,
  getEPA_VNE_PRODUCTCOMPONENT_Values,
  getVehicle_Values,
  getVehicleVin_Values,
  getConformanceDoc_Values,
  getFSI_FSI_LOT_LLL_Values,
  getFDADRU_LOTNUMSTUFF,
  getDEADEA_constituent_Values,
  getRepeatedArrivalLocation_Values,
  getCOMO_Values,
  getLACEY_ACT_REPEATED_Values,
  getLPCO_Values,
  getORRemarks_Values,
  getAdvanced_Containers,
  getCOLA_COLA_Values,
  get_REPEATED_PARTIES_PGA_Values,
  get_REPEATED_OMC_AQF_Values,
  get_REPEATED_NMF_370_HARVEST_Values,
  getPSX_REPEATED_INGREDIENT_Values,
  get_REPEATED_NMF_370_BOX5_Values,
  get_REPEATED_NMF_HMS_HARVEST_Values,
  get_REPEATED_NMF_HMS_DOCUMENT_Values,
  getCPSC_PRODUCT_IDENTIFIER_Values,
  getCPSC_ENTITY_ITL_Values,
  getCPSC_ENTITY_LAB_Values,
  getCPSC_CITATION_ITL_Values,
  getCPSC_CITATION_LAB_Values,
  getCPSC_CITATION_NOL_Values,
  getCPSC_TEST_REPORT_ITL_Values,
  getCPSC_TEST_REPORT_LAB_Values,
  checkInvoiceIsOpen
} from './initialValues'
import { updateEntryTypeField } from '../../actions/EntryTypeActions'
import { updateTransportationField } from '../../actions/TransportationInfoActions'
import { savePGAItemField } from '../../api/setFormData'
import { buildPortValue } from './index'
import { pgaTypes } from '../../formSections/pga/constantsPGA'
import {
  CPSC_CITATION_FIELDS,
  CPSC_ENTITY_FIELDS,
  CPSC_PRODUCT_IDENTIFIER_FIELDS,
  CPSC_REPEATED_LISTS,
  CPSC_TEST_REPORT_FIELDS,
} from '../../formSections/pga/CPSC_CPS/util'
import get from 'lodash/get'
import { ch82SetHtses } from '../../reducer/util'

export const assignValues = response => {

  const newValues = initialValues()

  // PSC 
  newValues.pscChain = get(response, 'pscChain', {})
  newValues.psc = get(response, 'psc', {})
  newValues.pscShipmentId = get(response, "pscShipmentId", "");

  //newValues.updateAvailable = get(response, 'updateAvailable', '')
  // IMPORTER
  newValues.importer.importer.importerIdInfo= get(response, 'importer.importerIdInfo', {})
  newValues.importer.consignee.consigneeIdInfo= get(response, 'importer.consignee.consigneeIdInfo', {})
  newValues.importer.importer.name = get(response, 'importer.name', '')
  newValues.importer.importer.addressInfo = buildAddress(get(response, 'importer.addressInfo', null))
  newValues.importer.importer.importerId = get(response, 'importer.importerId', '')
  newValues.importer.sameAsFlags = get(response, 'importer.sameAsFlags', newValues.importer.sameAsFlags)
  newValues.importer.consignee.name = get(response, 'importer.consignee.name', '')
  newValues.importer.consignee.addressInfo = buildAddress(get(response, 'importer.consignee.addressInfo', null))
  newValues.importer.consignee.consigneeId = get(response, 'importer.consignee.consigneeId', '')
  newValues.importer.designatedNotifyParty = get(response, 'importer.designatedNotifyParty', '')
  newValues.importer.related = get(response, 'importer.related', 2)
  newValues.importer.usStateOfDestCode = get(response, 'importer.usStateOfDestCode', '')
  try {
    let newHeaderParties = response.importer.headerParties.map(
      (headerParty) => {
        let newHeaderParty = {
          sameAs:
            response.importer.sameAsFlags[mapHeaderPartyTypeToSameAsValue[headerParty.headerPartyType]],
          name: headerParty.name || '',
          headerId: headerParty.headerId || '',
          headerPartyType: headerParty.headerPartyType || null,
          mId: headerParty.mId || '',
          addressInfo: buildAddress(headerParty.addressInfo)
        }
        return newHeaderParty
      }
    )
    newValues.importer.headerParties = newHeaderParties
  } catch (e) {
    newValues.importer.headerParties = []
  }

  // ENTRY TYPE INFO
  newValues.entryTypeInfo = get(response, 'entryTypeInfo', {});
  newValues.entryTypeInfo.summaryDate = newValues.entryTypeInfo.summaryDate || { epochs: 0 };
  newValues.entryTypeInfo.releaseDate = newValues.entryTypeInfo.releaseDate || { epochs: 0 };
  newValues.entryTypeInfo.primaryStatementPrintDate = newValues.entryTypeInfo.primaryStatementPrintDate || { epochs: 0 };
  newValues.entryTypeInfo.clientBranch = newValues.entryTypeInfo.clientBranch || "";
  newValues.entryTypeInfo.gonumber = newValues.entryTypeInfo.gonumber || "";

  newValues.entryTypeInfo.useAggregated = response.useAggregated;
  newValues.entryTypeInfo.aggregationMethod = response.aggregationMethod;
  newValues.entryTypeInfo.isUnaggregatedLineDirty = response.isUnaggregatedLineDirty;
  newValues.entryTypeInfo.warehouseEntryInfo = get(response, 'warehouseEntryInfo', '');

  //recon Code
  newValues.reconInfo = get(response, 'reconInfo', {noReconInfo:true})
  if(JSON.stringify(newValues.reconInfo) == "{}"){
    newValues.reconInfo = {noReconInfo:true};
  }

  var portCode = get(response, 'entryTypeInfo.portCode', '');
  if( typeof portCode  == 'string'){
    newValues.entryTypeInfo.portCode = {id: portCode}
  } else {
    newValues.entryTypeInfo.portCode = portCode;
  }
  
  try {
    let checkDigit = ''
    let entryNumber = ''
    entryNumber = response.entryTypeInfo.entryNumber || ''
    if (entryNumber && entryNumber.length > 7) {
      checkDigit = entryNumber.slice(-1)
      entryNumber = entryNumber.slice(0, entryNumber.length - 1)
    }
    newValues.entryTypeInfo.entryNumber = entryNumber
    newValues.entryTypeInfo.checkDigit = checkDigit
  } catch (e) {
    newValues.entryTypeInfo.entryNumber = ''
    newValues.entryTypeInfo.checkDigit = ''
  }
  try {
    buildPortValue(response.entryTypeInfo.portCode, value =>
      updateEntryTypeField('portCode', value)
    )
  } catch (e) {
    buildPortValue('', value => updateEntryTypeField('portCode', value))
  }

  // BOND INFO
  newValues.bondInfo.bondType = get(response, 'bondInfo.bondType', '')
  newValues.bondInfo.suretyNumber = get(response, 'bondInfo.suretyNumber', '')
  newValues.bondInfo.bondValue = get(response, 'bondInfo.bondValue', '')
  newValues.bondInfo.bondWaiver = get(response, 'bondInfo.bondWaiver', false)
  newValues.bondInfo.bondWaiverReasonCode = get(response, 'bondInfo.bondWaiverReasonCode', '')
  newValues.bondInfo.additionalBonds = get(response, 'bondInfo.additionalBonds', [])

  // BOL INFO
  newValues.bolInfo.bol.bolnumber = get(response, 'bolInfo.bol.bolnumber', '')
  newValues.bolInfo.bol.boltype = get(response, 'bolInfo.bol.boltype', '')
  newValues.bolInfo.bol.bolHouseNumber = get(response, 'bolInfo.bol.bolHouseNumber', '')
  newValues.bolInfo.exportDate = get(response, 'bolInfo.exportDate', {})
  newValues.bolInfo.container = get(response, 'bolInfo.container', [])
  newValues.bolInfo.locationOfGoods = get(response, 'bolInfo.locationOfGoods', '')
  newValues.bolInfo.currentLocationOfGood = get(response, 'bolInfo.currentLocationOfGood', '')
  newValues.bolInfo.exportingCountry = get(response, 'bolInfo.exportingCountry', '')
  newValues.bolInfo.itDate = get(response, 'bolInfo.itDate', {})
  newValues.bolInfo.itNumber = get(response, 'bolInfo.itNumber', '')
  newValues.bolInfo.manifestQuantity.quantity = parseFloat(get(response, 'bolInfo.manifestQuantity.quantity', 0)).toFixed(2)
  newValues.bolInfo.manifestQuantity.units = get(response, 'bolInfo.manifestQuantity.units', '_BLANK_')
  newValues.bolInfo.nonAms = get(response, 'bolInfo.nonAms', '')
  newValues.bolInfo.splitBill = get(response, 'bolInfo.splitBill', '')
  newValues.bolInfo.airCarrierCode = get(response, 'bolInfo.airCarrierCode', '')

  newValues.bolInfo.engineBolInfo =  get(response, 'engineBolInfo', {})
  
  // TRANSPORATION INFO
  newValues.transportInfo.modeOfTransport = get(response, 'transportInfo.modeOfTransport', '')
  newValues.transportInfo.importDate = get(response, 'transportInfo.importDate', {})
  newValues.transportInfo.exportDate = get(response, 'transportInfo.exportDate', {})
  newValues.transportInfo.destTimeZone = get(response, 'transportInfo.destTimeZone', null)
  newValues.transportInfo.carrierIdOO = get(response, 'carrierId', null)
  newValues.transportInfo.arrivalDate = get(response, 'transportInfo.arrivalDate', {})
  newValues.transportInfo.vesselCode = get(response, 'transportInfo.vesselCode', '')
  newValues.transportInfo.tripInformation = get(response, 'transportInfo.tripInformation', '')
  newValues.transportInfo.flightNo = get(response, 'transportInfo.flightNo', '')
  newValues.transportInfo.importingCarrier = get(response, 'transportInfo.importingCarrier', '')
  newValues.transportInfo.truckNo = get(response, 'transportInfo.truckNo', '')
  newValues.transportInfo.centralizedExaminationSite = get(response, 'transportInfo.centralizedExaminationSite', '')
  newValues.transportInfo.airCarrierCode = get(response, 'transportInfo.airCarrierCode', '')
  window.airCarrierCode = get(response, 'transportInfo.airCarrierCode', '')
  
  newValues.transportInfo.nonAms = get(response, 'transportInfo.nonAms', '')
  newValues.transportInfo.splitBill = get(response, 'transportInfo.splitBill', '')
  newValues.transportInfo.foreignPortOfLadingCode ={
    id : get(response, 'transportInfo.foreignPortOfLadingCode', ''),
    title : get(response, 'transportInfo.foreignPortOfLading', ''),
    masterSet: !!get(response, 'transportInfo.foreignPortOfLading', ''),
  }
  newValues.transportInfo.USportOfUnladingCode ={
    id : get(response, 'transportInfo.USportOfUnladingCode', ''),
    title : get(response, 'transportInfo.USportOfUnlading', ''),
    masterSet: !!get(response, 'transportInfo.USportOfUnlading', ''),
  }

  /*
  
USportOfUnladingCode: {id: "4631", title: "Oakland, CA, ", masterSet: true}
arrivalDate: {epochs: 1539846000000}
centralizedExaminationSite: "A065"
exportDate: {epochs: -999}
foreignPortOfLadingCode: {id: "", title: ", ", masterSet: false}
*/
  // updateTransportationField('foreignPortOfLadingCode', {
  //   id: get(response, "transportInfo.foreignPortOfLadingCode", ""),
  //   masterSet: !!get(response, "transportInfo.foreignPortOfLadingCode", ""),
  //   title: get(response, "transportInfo.foreignPortOfLading", "")
  // })
  // updateTransportationField('USportOfUnladingCode', {
  //   id:get(response, "transportInfo.USportOfUnladingCode", ""),
  //   masterSet: !!get(response, "transportInfo.USportOfUnladingCode", ""),
  //   title:get(response, "transportInfo.USportOfUnlading", "")
  // });

  // DESCRIPTION OF MERCHANDISE
  newValues.descriptionOfMerchandise.grossWeight.weight = parseFloat(get(response, 'descriptionOfMerchandise.grossWeight.weight', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.grossWeight.weightUnits = get(response, 'descriptionOfMerchandise.grossWeight.weightUnits', '_BLANK_')
  newValues.descriptionOfMerchandise.totalValue = parseFloat(get(response, 'descriptionOfMerchandise.totalValue', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.manifestQuantity.quantity = get(response, 'descriptionOfMerchandise.manifestQuantity.quantity', 0)
  newValues.descriptionOfMerchandise.manifestQuantity.units = get(response, 'descriptionOfMerchandise.manifestQuantity.units', '_BLANK_')
  newValues.descriptionOfMerchandise.manufacturerId = get(response, 'descriptionOfMerchandise.manufacturerId', '')
  newValues.descriptionOfMerchandise.exportDate = get(response, 'descriptionOfMerchandise.exportDate', {})
  newValues.descriptionOfMerchandise.totalCharges = get(response, 'descriptionOfMerchandise.totalCharges', '')
  newValues.descriptionOfMerchandise.additions = get(response, 'descriptionOfMerchandise.additions',{})
  newValues.descriptionOfMerchandise.deletions = get(response, 'descriptionOfMerchandise.deletions', {})

  try {
    let newMerchandiseLineItems = response.descriptionOfMerchandise.entrySummaryInvoices.map( 
      (invoiceItem, index) => {
        let newInvoiceItem = invoiceItemData()
        newInvoiceItem.invoiceId = invoiceItem.invoiceId||''
        newInvoiceItem.invoiceNumber = invoiceItem.invoiceNumber||''
        newInvoiceItem.invoiceDate = invoiceItem.invoiceDate || '-999'
        newInvoiceItem.poNumber  = invoiceItem.poNumber ||''
        newInvoiceItem.totalCharges  = invoiceItem.totalCharges ||''
        newInvoiceItem.showLoader  = false
        newInvoiceItem.expandInvoiceItem  = checkInvoiceIsOpen(index)
        newInvoiceItem.frieghtCharges=(invoiceItem.frieghtCharges  ==="0.00" || invoiceItem.frieghtCharges  ==="-999.0") ?  "" :  invoiceItem.frieghtCharges||''
        newInvoiceItem.frieghtInsurance=(invoiceItem.frieghtInsurance  ==="0.00" || invoiceItem.frieghtInsurance  ==="-999.0") ?  "" :  invoiceItem.frieghtInsurance||''
        newInvoiceItem.otherDeductions=(invoiceItem.otherDeductions  ==="0.00" || invoiceItem.otherDeductions  ==="-999.0") ?  "" :  invoiceItem.otherDeductions||''
        newInvoiceItem.otherAdditions=(invoiceItem.otherAdditions  ==="0.00" || invoiceItem.otherAdditions  ==="-999.0") ?  "" :  invoiceItem.otherAdditions||''
        newInvoiceItem.totalEnteredValue=  (invoiceItem.totalEnteredValue  ==="0.00" || invoiceItem.totalEnteredValue  ==="-999.0") ?  "" : invoiceItem.totalEnteredValue||''
        newInvoiceItem.invoiceAmount  =  (invoiceItem.invoiceAmount  ==="0.00" || invoiceItem.invoiceAmount  ==="-999.0") ?  "" : invoiceItem.invoiceAmount ||'' 
        let merchandiseLineItemsList  = []
    if (invoiceItem.hasOwnProperty("merchandiseLineItems")===true){
      merchandiseLineItemsList=invoiceItem.merchandiseLineItems.map(mapLineItem)
      newInvoiceItem.merchandiseLineItems = merchandiseLineItemsList
    } else {
      newInvoiceItem.merchandiseLineItems = []
    }
       return  newInvoiceItem
      }
    )
    newValues.descriptionOfMerchandise.entrySummaryInvoices =
      newMerchandiseLineItems || []
  } catch (e) {
    console.log('Error setting values', e)
    newValues.descriptionOfMerchandise.entrySummaryInvoices = []
  }

  // TOTALS
  newValues.descriptionOfMerchandise.hmf.fee = parseFloat(get(response, 'hmf.fee', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.mpf.fee = parseFloat(get(response, 'mpf.fee', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.duty = parseFloat(get(response, 'duty', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.tax = parseFloat(get(response, 'tax', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.irInfo= get(response, 'irInfo', {})
  newValues.descriptionOfMerchandise.fee = parseFloat(get(response, 'fee', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.bondedAdDutyAmt = parseFloat(get(response, 'bondedAdDutyAmt', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.bondedCvdDutyAmt = parseFloat(get(response, 'bondedCvdDutyAmt', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.cashAdDutyAmt = parseFloat(get(response, 'cashAdDutyAmt', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.cashCvdDutyAmt = parseFloat(get(response, 'cashCvdDutyAmt', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.grandTotal = parseFloat(get(response, 'grandTotal', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.other = parseFloat(get(response, 'other', 0)).toFixed(2)
  newValues.descriptionOfMerchandise.bolDocId = get(response, 'bolDocId', '')
  newValues.descriptionOfMerchandise.additionalDuties = get(response, 'additionalDuties', {})
  newValues.descriptionOfMerchandise.additionalDuties.userFees = get(response, 'additionalDuties.userFees', [])

  // Declaration Section
  newValues.declarationSection.actualOwnerFlag = (get(response, 'actualOwnerFlag', '')).toString()
  newValues.declarationSection.purchaserFlag = (get(response, 'purchaserFlag', '')).toString()
  newValues.declarationSection.trueInvoiceFlag = (get(response, 'trueInvoiceFlag', '')).toString()
  newValues.declarationSection.bestInvoiceFlag = (get(response, 'bestInvoiceFlag', '')).toString()
  newValues.fieldValidations.fields = get(response, 'fieldValidations.fields', [])

  //referenceSection
  newValues.descriptionOfMerchandise.referenceType = get(response, 'referenceType', "NONE")
  newValues.descriptionOfMerchandise.referenceNumber = get(response, 'referenceNumber', "NONE")
 
  return newValues
}

// build address
const buildAddress = addressInfo => {
  let address = {
    STREET_NAME: [],
    CITY: '',
    COUNTRY_SUB_ENTITY: '',
    POSTAL_CODE: '',
    COUNTRY: ''
  }
  for(let oneAddressInfo of addressInfo||[]) {
    if (oneAddressInfo.type === 'STREET_NUMBER') {
      address.STREET_NAME.unshift(oneAddressInfo.information)
    } else if (oneAddressInfo.type === 'STREET_NAME') {
      address.STREET_NAME.push(oneAddressInfo.information)
    } else {
      address[oneAddressInfo.type] = oneAddressInfo.information;
    }
  }
  address.STREET_NAME = address.STREET_NAME.join(' ')
  return address
}

// export const convertLaceyActItems = (pgaGuid, PGAItems, merchandiseId) => {
//   let result = getInitialLaceyAct()
//   PGAItems.forEach(item => {
//     if (singlePGAItems[item.PGAId]) {
//       // set Singular field on result with key = PGAId
//       if (item.PGAId === 'dateOfSign' && (!item.value || item.value.toString() === '-999')) {
//         item.value = Date.now()
//         savePGAItemField(pgaGuid, [item], merchandiseId, pgaTypes.LACEY)
//       }
//       if (!item.value) {
//         if (item.PGAId === 'declarationCert') {
//           item.value = '2'
//         } else {
//           item.value = ''
//         }
//       }
//       result[item.PGAId] = item
//     } else if (repeatedPGAItems[item.PGAId]) {
//       // If any item does not have a value existing, provide empty string default
//       if (!item.value) {
//         item.value = ''
//       }
//       // Handle All repeated fields
//       if (PGAItemFields[item.PGAId]) {
//         // Handle PGAItem fields
//         let pgaItemIndex = parseInt(item.key.split('.')[1]) - 1 // Get Index that PGA Item field needs to be at in our result
//         if (!result.PGAItemList[pgaItemIndex]) {
//           // Handle case that the index in the result for PGAITemsList does not exist yet (i.e first time we are seeing a field of this repeat number)
//           let newPGAItem = getNewPGAItem(pgaItemIndex)
//           newPGAItem[item.PGAId] = item
//           result.PGAItemList[pgaItemIndex] = newPGAItem
//         } else {
//           // Handle case that the index in the result for PGAITemsList DOES exist already
//           result.PGAItemList[pgaItemIndex][item.PGAId] = item
//         }
//       }
//       // Container Case
//       if (item.PGAId === 'containerNum') {
//         let containerIndex = parseInt(item.key.split('.')[1]) - 1
//         result.containers[containerIndex] = item
//       }
//     }
//   })
//   result.merchandiseId = merchandiseId
//   return result
// }
function flattenJsonObject(input, result = []) {
  if (Array.isArray(input)) {
      input.forEach(item => flattenJsonObject(item, result));
  } else if (typeof input === "object" && input !== null) {
      if(input?.key){
        result.push(input)
      }
      else{
        Object.entries(input).forEach(([key, value]) => {
          if(key!=="regexx"){
            if (Array.isArray(value) || (typeof value === "object" && value !== null)) {
              flattenJsonObject(value, result);
            }
          }
        });
      }
  }
  return result;
}
export const makeFlatListForPgaItemsForProductHistory = (pgaData) => {
    let flatPgaData = {};
    Object.keys(pgaData).forEach((pgaKey) => {
      let pgas = pgaData[pgaKey];
      
      Object.keys(pgas).map((item, index)=>{
        let pgaItem = pgaData[pgaKey][item];
        let flatPgaList = flattenJsonObject(pgaItem);
        flatPgaData[item] = flatPgaList;
      })
    })
    return flatPgaData;
}

export const mapFlatListWithAllPgaData = (flatPgaLists, allPgaData)  => {
  let transformedAllPgaData = allPgaData.pgaData.pgaActData.map((item, index)=>{
    let {pgaGuid, pgaType} = item;
    item.pgaItems = flatPgaLists[`${pgaType}__#_${pgaGuid}`];
    item.PGAItems = flatPgaLists[`${pgaType}__#_${pgaGuid}`];
    return item;
  })
  allPgaData.pgaData.pgaActData = transformedAllPgaData;
  return allPgaData;
}

export const convertFDAFOOItems = (PGAItems, merchandiseId,pgaGuid, targetPGA, isManuallyAdded=false) => {
  if (targetPGA === 'CPSC_CPS') {
    targetPGA = pgaTypes.CPSC
  }
  let result = getInitialFDAFOO()
  result.error = null
  function initValuesObject(result,item,initFunction, keyname){
    // Handle PGAItem fields
    if(!item.id)item.id=Math.random()+"_"+Math.random()+"_"+Math.random();
    let index = parseInt(item.key.split('.')[1]) - 1 // Get Index that PGA Item field needs to be at in our result
    let hasSecondLevel = item.key.split('.').length >= 3;
    let hasThirdLevel = item.key.split('.').length >= 4;
    let secondIndex = 0;
    let thirdIndex = 0;
    if(hasSecondLevel){
      secondIndex = parseInt(item.key.split('.')[2]) - 1 
    }
    if(hasThirdLevel){
      thirdIndex = parseInt(item.key.split('.')[3]) - 1 
    }
    result[keyname] =result[keyname]  || [];
    if (!result[keyname][index]) {
      
      // Handle case that the index in the result for PGAITemsList does not exist yet (i.e first time we are seeing a field of this repeat number)
      let listItem = initFunction(index + 1)
      listItem[item.PGAId] = item
      if(hasThirdLevel){
        result[keyname][index] = result[keyname][index] || [];
        result[keyname][index][secondIndex] = result[keyname][index][secondIndex] || []
        result[keyname][index][secondIndex][thirdIndex] = listItem;
      } else if(hasSecondLevel){
        result[keyname][index] = result[keyname][index] || [];
        result[keyname][index][secondIndex] = listItem
        
      } else {
        result[keyname][index] = listItem
      }
    } else {
      // Handle case that the index in the result for PGAITemsList DOES exist already
      if(hasThirdLevel){
        result[keyname][index][secondIndex] = result[keyname][index][secondIndex]  || [];
        result[keyname][index][secondIndex][thirdIndex] = result[keyname][index][secondIndex][thirdIndex]  || {};
        result[keyname][index][secondIndex][thirdIndex][item.PGAId] = item
      } else if(hasSecondLevel){
        result[keyname][index][secondIndex] = result[keyname][index][secondIndex] || {};
        result[keyname][index][secondIndex][item.PGAId] = item
        
      } else {
        result[keyname][index][item.PGAId] = item
      }
    }
  }
  for(let oneItem of (PGAItems||[])){
    if(targetPGA.indexOf("FDA")==0){
      if(oneItem.PGAId == "productCodeNo" || oneItem.PGAId == "fdaProductCodeNumber"){
        oneItem.regexx = /^\d{2}[a-zA-Z0-9][\-a-zA-Z]{2}[a-zA-Z0-9]{2}$/
        oneItem.regexxdescription = `the correct format. Should be 7 characters.
        Position 1,2: 'N'. 
        Position 3,6,7: 'A' or 'N'.
        Position 4,5: 'A' or -.
        Where 'A' is alphabetic and 'N' is numeric.
        Example of a FDA Product Code = 70DY-99`
      }
    }
    
      if(oneItem && (oneItem.PGAId == "commercialDesc" || oneItem.PGAId == "commodityDescription")){
        oneItem.lengthClass="1000X";
      }
  }
  (PGAItems||[]).filter(a=>a.key).forEach(item => {
    item.id=item.id || Math.random()+"_"+Math.random();
    let hasrepeated = item.key.split('.').length>1;
    let pgasWithRepeatedLotnum = ['FDA_DRU','AMS_OR','FSI_FSI', 'AMS_OR2']
    let isIrregularLotNumstuff = !(FDADRU_LOTNUM_Values[item.PGAId] && !(pgasWithRepeatedLotnum.indexOf(targetPGA)>=0));
    let repeatedPGA = repeatedFDAFOOItems[item.PGAId] && isIrregularLotNumstuff;
    let isFSIPGA = targetPGA.indexOf('FSI_FSI')>=0;
    let NHTPGAList = ['NHT_MVS','NHT_OFF','NHT_OEI']
    let notlacey = targetPGA.indexOf('LACEY')<0
    if (repeatedPGA && hasrepeated) {
      // Handle All repeated fields
      let notaph = (targetPGA.indexOf('APH_')<0);
      if (CPSC_ENTITY_ITL_FIELDS[item.PGAId] && targetPGA === pgaTypes.CPSC) {
        initValuesObject(result, item, getCPSC_ENTITY_ITL_Values, CPSC_REPEATED_LISTS.ENTITY_ITL);
      } else if (CPSC_ENTITY_LAB_FIELDS[item.PGAId] && targetPGA === pgaTypes.CPSC) {
        initValuesObject(result, item, getCPSC_ENTITY_LAB_Values, CPSC_REPEATED_LISTS.ENTITY_LAB);
      } else if (CPSC_CITATION_ITL_FIELDS[item.PGAId] && targetPGA === pgaTypes.CPSC) {
        initValuesObject(result, item, getCPSC_CITATION_ITL_Values, CPSC_REPEATED_LISTS.CITATION_ITL);
      } else if (CPSC_CITATION_LAB_FIELDS[item.PGAId] && targetPGA === pgaTypes.CPSC) {
        initValuesObject(result, item, getCPSC_CITATION_LAB_Values, CPSC_REPEATED_LISTS.CITATION_LAB);
      } else if (CPSC_TEST_REPORT_ITL_FIELDS[item.PGAId] && targetPGA === pgaTypes.CPSC) {
        initValuesObject(result, item, getCPSC_TEST_REPORT_ITL_Values, CPSC_REPEATED_LISTS.TEST_REPORT_ITL);
      } else if (CPSC_TEST_REPORT_LAB_FIELDS[item.PGAId] && targetPGA === pgaTypes.CPSC) {
        initValuesObject(result, item, getCPSC_TEST_REPORT_LAB_Values, CPSC_REPEATED_LISTS.TEST_REPORT_LAB);
      } else if (CPSC_CITATION_NOL_FIELDS[item.PGAId] && targetPGA === pgaTypes.CPSC) {
        initValuesObject(result, item, getCPSC_CITATION_NOL_Values, CPSC_REPEATED_LISTS.CITATION_NOL);
      } else if (CPSC_PRODUCT_IDENTIFIER_LOOKUP[item.PGAId] && targetPGA === pgaTypes.CPSC) {
        initValuesObject(result, item, getCPSC_PRODUCT_IDENTIFIER_Values, CPSC_REPEATED_LISTS.PRODUCT_IDENTIFIER);
      } else if (FDAFOO_AOC_Fields[item.PGAId]) {
        initValuesObject(result,item,getFDAFOO_AOC, 'FDAFOO_AOC_List');
      } else if (SIMPLE_LPCO_VALUES[item.PGAId] && targetPGA.indexOf('EPA_VNE')>=0){///////////
        initValuesObject(result,item,getSIMPLE_LPCO_VALUES,'SIMPLE_LPCO_VALUES');//////////
      } else if (AMS_OR2_LPCOTRANSACTION[item.PGAId] && targetPGA.indexOf('AMS_OR2')>=0){
        initValuesObject(result,item,getAMS_OR2_LPCOTRANSACTION_Values,'AMS_OR2_LPCOTRANSACTION');
      } else if (AMS_OR2_LOTNUMBER[item.PGAId] && targetPGA.indexOf('AMS_OR2')>=0){
        initValuesObject(result,item,getAMS_OR2_LOTNUMBER_Values,'AMS_OR2_LOTNUMBER');
      } else if (LACEY_ACT_REPEATED[item.PGAId] && targetPGA.indexOf('LACEY')>=0){
        initValuesObject(result,item,getLACEY_ACT_REPEATED_Values,'LACEY_ACT_REPEATED');
      } else if (ATFATF_LICENSE_Fields[item.PGAId] && targetPGA=="ATF_ATF") {
        initValuesObject(result,item,getATFATF_LICENSE_Values, 'ATFATF_LICENSE_Values');
      } else if (PSX_REPEATED_INGREDIENT_Fields[item.PGAId] && targetPGA.indexOf('EPA_PS')>=0){
        initValuesObject(result,item,getPSX_REPEATED_INGREDIENT_Values, 'PSX_REPEATED_INGREDIENT_Values');
      } else if (FDAFOO_PQ_Fields[item.PGAId]) {
        initValuesObject(result,item,getFDAFOO_PQ, 'FDAFOO_PQ_List');
      } else if (FDAFOO_SOURCE_TYPE_Fields[item.PGAId] && notaph && notlacey) {
        // Handle PGAItem fields
        let index = parseInt(item.key.split('.')[1]) - 1 // Get Index that PGA Item field needs to be at in our result
        if (!result.FDAFOO_SOURCE_TYPE_List[index]) {
          // Handle case that the index in the result for PGAITemsList does not exist yet (i.e first time we are seeing a field of this repeat number)
          let listItem = getFDAFOO_SOURCE_TYPE(index)
          listItem[item.PGAId] = item
          result.FDAFOO_SOURCE_TYPE_List[index] = listItem
        } else {
          // Handle case that the index in the result for PGAITemsList DOES exist already
          result.FDAFOO_SOURCE_TYPE_List[index][item.PGAId] = item
        }//EPA_VNE_PRODUCTCOMPONENT_Fields
      } else if (isFSIPGA && FSI_FSI_LOT_LLL_Fields[item.PGAId]){
        initValuesObject(result,item,getFSI_FSI_LOT_LLL_Values, 'FSI_FSI_LOT_LLL_Values');
      } else if (EPA_VNE_PRODUCTCOMPONENT_Fields[item.PGAId]) {
        initValuesObject(result,item,getEPA_VNE_PRODUCTCOMPONENT_Values, 'EPA_VNE_PRODUCTCOMPONENT_Values');
      } else if (VEHICLE_INFO_Fields[item.PGAId]  && NHTPGAList.includes(targetPGA) ) {
        initValuesObject(result,item, getVehicle_Values, 'VEHICLE_INFO_Values');
      } else if (CONFORMANCE_DOC_Fields[item.PGAId] && NHTPGAList.includes(targetPGA)) {
        initValuesObject(result,item, getConformanceDoc_Values, 'CONFORMANCE_DOC_Values');
      } else if (VEHICLE_VIN_Fields[item.PGAId]  && NHTPGAList.includes(targetPGA)) {
        initValuesObject(result,item, getVehicleVin_Values, 'VEHICLE_VIN_Values');
      }else if (FDADRU_CONSTITUENT_ELEMENT_Values[item.PGAId] && targetPGA==='FDA_DRU') {
        initValuesObject(result,item,getFDADRU_CONSTITUENT_ELEMENT, 'FDADRU_CONSTITUENT_ELEMENT_Values');
      } else if (FDADRU_LOTNUM_Values[item.PGAId]) {
        initValuesObject(result,item,getFDADRU_LOTNUMSTUFF, 'FDADRU_LOTNUM_Values');
      } else if (APHAVS_COMO_Values[item.PGAId]){
        initValuesObject(result,item,getCOMO_Values,'APHAVS_COMO_Values');
      } else if (APHAVS_LPCO_VALUES[item.PGAId]){
        initValuesObject(result,item,getLPCO_Values,'APHAVS_LPCO_Values');
      } else if (ORRemarks_Values[item.PGAId]){
        initValuesObject(result,item,getORRemarks_Values,'ORRemarks_Values');
      } else if (DEADEA_CONSTITUENT_Fields[item.PGAId]){
        initValuesObject(result,item,getDEADEA_constituent_Values,'DEADEA_constituent_Values');
      } else if (RepeatedArrivalLocation_Fields[item.PGAId] && targetPGA=='APH_APQ'){
        initValuesObject(result,item,getRepeatedArrivalLocation_Values,'RepeatedArrivalLocation_Values');
      } else if (APHAVS_NAMEANDCODE_COMPONENT_Fields[item.PGAId]){//MUST COME AFTER FDAFOO_SOURCE_TYPE_Fields because they have the same keys!
        if(item.key.split(".").length==2)item.key+=".1"
        initValuesObject(result,item,getAPHAVS_NAMEANDCODE_COMPONENT,'APHAVS_NAMEANDCODE_COMPONENT_Values');
      } else if (APHAVS_COMMODITY_COMPONENT_Fields[item.PGAId]){//MUST COME AFTER FDAFOO_SOURCE_TYPE_Fields because they have the same keys!
        initValuesObject(result,item,getAPHAVS_COMMODITY_COMPONENT,'APHAVS_COMMODITY_COMPONENT_Values');
      } else if (APHAVS_SRC_TYPE_QQ_Component_Fields[item.PGAId]){//MUST COME AFTER FDAFOO_SOURCE_TYPE_Fields because they have the same keys!
        if(item.key.split(".").length==2)item.key+=".1"
        initValuesObject(result,item,getAPHAVS_SOURCE_TYPE_COMPONENT,'APHAVS_SOURCE_TYPE_COMPONENT_Values');
      } else if (APHAVS_NAMEANDCODE_PRODUCT_Fields[item.PGAId]){//MUST COME AFTER FDAFOO_SOURCE_TYPE_Fields because they have the same keys!
        if(item.key.split(".").length==2)item.key+=".1"
        initValuesObject(result,item,getAPHAVS_NAMEANDCODE_PRODUCT,'APHAVS_NAMEANDCODE_PRODUCT_Values');
      } else if (APHAVS_COMMODITY_PRODUCT_Fields[item.PGAId]){//MUST COME AFTER FDAFOO_SOURCE_TYPE_Fields because they have the same keys!
        initValuesObject(result,item,getAPHAVS_COMMODITY_PRODUCT,'APHAVS_COMMODITY_PRODUCT_Values');
      } else if (APHAVS_SRC_TYPE_QQ_Product_Fields[item.PGAId]){//MUST COME AFTER FDAFOO_SOURCE_TYPE_Fields because they have the same keys!
        if(item.key.split(".").length==2)item.key+=".1"
        initValuesObject(result,item,getAPHAVS_SOURCE_TYPE_PRODUCT,'APHAVS_SOURCE_TYPE_PRODUCT_Values');
      } else if (!isFSIPGA && APHAVS_NAMEANDCODE_Fields[item.PGAId]){//MUST COME AFTER FDAFOO_SOURCE_TYPE_Fields because they have the same keys!
        initValuesObject(result,item,getAPHAVS_NAMEANDCODE,'APHAVS_NAMEANDCODE_Values');
      } else if (!isFSIPGA && APHAVS_COMMODITY_Fields[item.PGAId]){//MUST COME AFTER FDAFOO_SOURCE_TYPE_Fields because they have the same keys!
        initValuesObject(result,item,getAPHAVS_COMMODITY,'APHAVS_COMMODITY_Values');
      } else if (APHAVS_SRC_TYPE_QQ_Fields[item.PGAId]  && notlacey && !(["NMFS_HMS","NMFS_AMR","NMFSHMS","NMFSAMR"].includes(targetPGA))){//MUST COME AFTER FDAFOO_SOURCE_TYPE_Fields because they have the same keys!
        initValuesObject(result,item,getAPHAVS_SOURCE_TYPE,'APHAVS_SOURCE_TYPE_Values');
      } else if (COLA_COLA_Fields[item.PGAId] && targetPGA.includes('TTB_')) {
        initValuesObject(result,item,getCOLA_COLA_Values,'COLA_COLA_Values');
      } else if (REPEATED_PARTIES_PGA_FIELDS[item.PGAId]) {
        initValuesObject(result,item,get_REPEATED_PARTIES_PGA_Values,'REPEATED_PARTIES_PGA_Values');
      } else if (REPEATED_OMC_AQF_FIELDS[item.PGAId]) {
        initValuesObject(result,item,get_REPEATED_OMC_AQF_Values,'REPEATED_OMC_AQF_Values');
      } else if (item.PGAId === 'containerNum') {
        let containerIndex = parseInt(item.key.split('.')[1]) - 1
        result.containers[containerIndex] = item
      }
      if(ContainerItemFields[item.PGAId]){
        initValuesObject(result,item,getAdvanced_Containers,'CONTAINERS_ADVANCED');

      }
      if(REPEATED_NMF_370_HARVEST_FIELDS[item.PGAId] && ["NMF_370", "NMF370"].includes(targetPGA)) {
        initValuesObject(result,item,get_REPEATED_NMF_370_HARVEST_Values,'REPEATED_NMF_370_HARVEST_Values');
      }
      if(REPEATED_NMF_370_BOX5_FIELDS[item.PGAId] && ["NMF_370", "NMF370"].includes(targetPGA)) {
        initValuesObject(result,item,get_REPEATED_NMF_370_BOX5_Values,'REPEATED_NMF_370_BOX5_Values');
      }
      if(REPEATED_NMF_HMS_HARVEST_FIELDS[item.PGAId] && (["NMFS_HMS","NMFS_AMR","NMFSHMS","NMFSAMR"].includes(targetPGA))) {
        initValuesObject(result,item,get_REPEATED_NMF_HMS_HARVEST_Values,'REPEATED_NMF_HMS_HARVEST_Values');
      }
      if(REPEATED_NMF_HMS_DOCUMENT_FIELDS[item.PGAId] && (["NMFS_HMS","NMFS_AMR", "NMFSHMS","NMFSAMR"].includes(targetPGA))) {
        initValuesObject(result,item,get_REPEATED_NMF_HMS_DOCUMENT_Values,'REPEATED_NMF_HMS_DOCUMENT_Values');
      }
      
    } else {
      // set Singular field on result with key = PGAId
      if (item.PGAId === 'dateOfSign' && (!item.value || item.value.toString() === '-999') && pgaGuid) {
        item.value = Date.now().toString()
        savePGAItemField(pgaGuid, [item], merchandiseId, targetPGA)
      }
      if (!item.value) {
        if (item.PGAId === 'declarationCert') {
          item.value = '2'
        } else {
          item.value = ''
        }
      }
      result[item.PGAId] = item
    }
  })
  result.pgaGuid = pgaGuid;
  result.merchandiseId = merchandiseId
  if (targetPGA === pgaTypes.CPSC) {
    result[CPSC_REPEATED_LISTS.PRODUCT_IDENTIFIER] = result[CPSC_REPEATED_LISTS.PRODUCT_IDENTIFIER] || []
    result[CPSC_REPEATED_LISTS.ENTITY_ITL] = result[CPSC_REPEATED_LISTS.ENTITY_ITL] || []
    result[CPSC_REPEATED_LISTS.ENTITY_LAB] = result[CPSC_REPEATED_LISTS.ENTITY_LAB] || []
    result[CPSC_REPEATED_LISTS.CITATION_ITL] = result[CPSC_REPEATED_LISTS.CITATION_ITL] || []
    result[CPSC_REPEATED_LISTS.CITATION_LAB] = result[CPSC_REPEATED_LISTS.CITATION_LAB] || []
    result[CPSC_REPEATED_LISTS.CITATION_NOL] = result[CPSC_REPEATED_LISTS.CITATION_NOL] || []
    result[CPSC_REPEATED_LISTS.TEST_REPORT_ITL] = result[CPSC_REPEATED_LISTS.TEST_REPORT_ITL] || []
    result[CPSC_REPEATED_LISTS.TEST_REPORT_LAB] = result[CPSC_REPEATED_LISTS.TEST_REPORT_LAB] || []
    const nestedListNames = [
      CPSC_REPEATED_LISTS.CITATION_ITL,
      CPSC_REPEATED_LISTS.CITATION_LAB,
      CPSC_REPEATED_LISTS.TEST_REPORT_ITL,
      CPSC_REPEATED_LISTS.TEST_REPORT_LAB,
    ]
    nestedListNames.forEach((listName) => {
      const list = result[listName] || []
      const firstItem = list[0]
      if (firstItem && !Array.isArray(firstItem)) {
        const normalizedRows = list
          .filter(Boolean)
          .map((row, rowIndex) => {
            if (!row || typeof row !== 'object') return row
            const nextRow = { ...row }
            Object.keys(nextRow).forEach((fieldName) => {
              const field = nextRow[fieldName]
              if (!field?.key) return
              const baseKey = `${field.key}`.split('.')[0]
              nextRow[fieldName] = {
                ...field,
                key: `${baseKey}.1.${rowIndex + 1}`,
              }
            })
            return nextRow
          })
        result[listName] = [normalizedRows]
      }
    })
  }
  if(isManuallyAdded=="true"){
    result.isManuallyAddedPga = true;
  }
  return result
}

// export const convertTSCAItems = (pgaGuid, PGAItems, merchandiseId) => {
//   let result = getInitialTSCA()
//   PGAItems.forEach(item => {
//     if (singleTSCAItems[item.PGAId]) {
//       // set Singular field on result with key = PGAId
//       if (item.PGAId === 'dateOfSign' && (!item.value || item.value.toString() === '-999')) {
//         item.value = Date.now()
//         savePGAItemField(pgaGuid, [item], merchandiseId, pgaTypes.TSCA)
//       }
//       if (!item.value) {
//         if (item.PGAId === 'declarationCert') {
//           item.value = '2'
//         } else {
//           item.value = ''
//         }
//       }
//       result[item.PGAId] = item
//     } else if (repeatedTSCAItems[item.PGAId]) {
//       // If any item does not have a value existing, provide empty string default (I beleive this is extraneous within TSCA since it does not have the repeated items but to be safe I added it here)
//       if (!item.value) {
//         item.value = ''
//       }
//       // Handle All repeated fields
//       if (PGAItemFields[item.PGAId]) {
//         // Handle PGAItem fields
//         let pgaItemIndex = parseInt(item.key.split('.')[1]) - 1 // Get Index that PGA Item field needs to be at in our result
//         if (!result.PGAItemList[pgaItemIndex]) {
//           // Handle case that the index in the result for PGAITemsList does not exist yet (i.e first time we are seeing a field of this repeat number)
//           let newPGAItem = getNewPGAItem(pgaItemIndex)
//           newPGAItem[item.PGAId] = item
//           result.PGAItemList[pgaItemIndex] = newPGAItem
//         } else {
//           // Handle case that the index in the result for PGAITemsList DOES exist already
//           result.PGAItemList[pgaItemIndex][item.PGAId] = item
//         }
//       }
//     }
//   })
//   if (!result.declarationCode.value && !result.disclaimCode.value) {
//     result.declarationCode.value = 'EP4'
//     savePGAItemField(pgaGuid, [result.declarationCode], merchandiseId, pgaTypes.TSCA)
//   }
//   return result
// }

// export const convertFDAItems = (pgaGuid, PGAItems, merchandiseId) => {
//   let result = getInitialFDA()
//   PGAItems.forEach(item => {
//     // set Singular field on result with key = PGAId
//     if (item.PGAId === 'dateOfSign' && (!item.value || item.value.toString() === '-999')) {
//       item.value = Date.now()
//       savePGAItemField(pgaGuid, [item], merchandiseId, pgaTypes.DISCLAIM_PGA)
//     }
//     if (!item.value) {
//       if (item.PGAId === 'disclaimCode') {
//         item.value = 'A'
//         savePGAItemField(pgaGuid, [item], merchandiseId, pgaTypes.DISCLAIM_PGA)
//       } else {
//         item.value = ''
//       }
//     }
//     result[item.PGAId] = item
//   })
//   return result
// }


// export const convertNHTSAItems = (pgaGuid, PGAItems, merchandiseId) => {
//   let result = getInitialNHTSA()
//   PGAItems.forEach(item => {
//     // set Singular field on result with key = PGAId
//     if (item.PGAId === 'dateOfSign' && (!item.value || item.value.toString() === '-999')) {
//       item.value = Date.now()
//       savePGAItemField(pgaGuid, [item], merchandiseId, pgaTypes.NHTSA)
//     }
//     if (!item.value) {
//       if (item.PGAId === 'disclaimCode') {
//         item.value = 'A'
//         savePGAItemField(pgaGuid, [item], merchandiseId, pgaTypes.NHTSA)
//       } else {
//         item.value = ''
//       }
//     }
//     result[item.PGAId] = item
//   })
//   return result
// }

// MAP of smaeAs names
const mapHeaderPartyTypeToSameAsValue = {
  CONSIGNEE: 'consigneeAsImporter',
  BUYER: 'buyerAsImporter',
  // MANUFACTURER: 'manufacturerAsShipper',
  STUFFER: 'containerStufferAsManufacturer',
  SHIP_TO: 'notifyPartyAsImporter',
  // SELLER: 'sellerAsShipper',
  CONSOLIDATOR: 'consolidatorAsShipper'
}

// Fields that are expected to only occur once on Laccey Act
const singlePGAItems = {
  commercialDesc: true,
  charDesc: true,
  individualName: true,
  telNumber: true,
  email: true,
  city: true,
  state: true,
  disclaimFlag: true,
  disclaimCode: true,
  zip: true,
  country: true,
  declarationCert: true,
  dateOfSign: true,
  entityAddress1: true
}

// Fields that are expected to only occur once on TSCA
const singleTSCAItems = {
  declarationCert: true,
  dateOfSign: true,
  disclaimCode: true,
  disclaimFlag: true,
  declarationCode: true,
  commercialDesc: true
}

// Fields that are repeated on Lacey Act
const repeatedPGAItems = {
  genusName: true,
  speciesName: true,
  countryCode: true,
  indgredientQuantity: true,
  indgredientName: true,
  indgredientUom: true,
  containerNum: true
}

// Fields that are repeated on TSCA
const repeatedTSCAItems = {}

// Fields that are repeated on FDA FOO


const APHAVS_COMO_Values = {
  comoRoutingCountryCode: true,
  comoRoutingRegionCode: true,
  comoRoutingTypeCode: true,
}
const DEADEA_CONSTITUENT_Fields = {
  productCodeQualifier: true,
  productCodeNo: true,
  constituentElementUnitOfMeasure: true,
  constituentElementQuantity: true,
  
}
const RepeatedArrivalLocation_Fields = {
  testingStatus: true,
  arrivalDate: true,
  arrivalLocation: true,
}
const ORRemarks_Values = {
  remarksText: true,
  remarksTypeCode: true,
  remarksCode: true
}
const SIMPLE_LPCO_VALUES = {
  lpcoNumber: true,
  lpcoType: true,
}
const APHAVS_LPCO_VALUES = {
  lcpoDate: true,
  lcpoDateQual: true,
  lcpoIssuer: true,
  lcpoLocation: true,
  lcpoLocationDesc: true,
  lcpoTxnType: true,
  lcpoNumber: true,
  lcpoQuantity: true,
  lcpoType: true,
  lcpoUom: true,
}
const EPA_VNE_PRODUCTCOMPONENT_Fields = {
  modelProduct: true,
  mfgMonthYearProduct: true,
  qualifierProduct: true,
  identityNumberProduct: true,
  modelComponent: true,
  mfgMonthYearComponent: true,
  qualifierComponent: true,
  identityNumberComponent: true,
  addComponent: true,
}

const ADDITIONAL_CONFORMANCE_DOC = {
  documentIdentifier: true
}

const VEHICLE_INFO_Fields = {
  model: true,
  manufactureMonthAndYear: true,
  categoryCode: true,
  commodityQualCode: true,
  commodityCharQual: true
}
const VEHICLE_VIN_Fields = {
  itemIdentity: true
}
const CONFORMANCE_DOC_Fields = {
  documentIdentifier: true
}
const FSI_FSI_LOT_LLL_Fields = {
  commodityCharQual : true,
  entityNumberEXE : true,
  entityNumberPE : true,
  entityNumberSOE: true,
  productionStartDate : true,
  productionEndDate : true,
  quantitypgaNet : true,
  packagingIdentifier : true,
  categoryCode : true,
  commodityQualCode : true,
}


const ContainerItemFields = {
  containerNum: true,
  containerLength: true,
  containerType: true,

}
const FDAFOO_SOURCE_TYPE_Fields = {
  sourceTypeCode: true,
  country: true,
}
const APHAVS_NAMEANDCODE_Fields = {
  categoryCode: true,
  // commonName: true
}

const APHAVS_COMMODITY_Fields =  {
  commodityQualCode: true,
  charDesc: true,
  commodityCharQual: true,
}


const COLA_COLA_Fields = {
  colaNumber: true,
  colaExemptionCode: true,
}

const REPEATED_PARTIES_PGA_FIELDS = {
  partiesContactDetails:true,
  partiesContactEmail: true,
  partiesAddressAptNumber:true,
  partiesName:true,
  partiesCountry:true,
  partiesAddressLine2:true,
  partiesAddressLine1:true,
  partiesPostalCode:true,
  partiesState:true,
  partiesContactName:true,
  partiesContactPhoneNumber:true,
  partiesType:true,
  partiesCity:true,
}

const REPEATED_OMC_AQF_FIELDS = {
  entityNameAQF: true,
  entityAddress1AQF: true,
  entityAddress2AQF: true,
  cityAQF: true,
  stateAQF: true,
  countryAQF: true,
  zipAQF: true,
}

const REPEATED_NMF_370_HARVEST_FIELDS = {
  gearType: true,
  geographicLocation: true
}

const REPEATED_NMF_370_BOX5_FIELDS = {
  boxBDolphCertSafeChoices: true,
  boxBDolphCertSafe: true
}

const REPEATED_NMF_HMS_HARVEST_FIELDS = {
  gearType: true,
  geographicLocation: true,
  vesselFlag: true,
  countryCode: true
}

const REPEATED_NMF_HMS_DOCUMENT_FIELDS = {
  documentIdentifier: true,
  documentNumber: true
}

const APHAVS_SRC_TYPE_QQ_Fields = {
  sourceTypeCode: true,
  country: true,
  processingStartDate: true,
  processingEndDate: true,
  geographicLocation: true,
   processingTypeCode: true,
   processingDescription: true,
}
const APHAVS_NAMEANDCODE_PRODUCT_Fields = {
  categoryCodeProduct: true,
  commonNameProduct: true
}
const APHAVS_COMMODITY_PRODUCT_Fields =  {
  commodityQualCodeProduct: true,
  charDescProduct: true,
  commodityCharQualProduct: true,
}
const APHAVS_SRC_TYPE_QQ_Product_Fields = {
  sourceTypeCodeProduct: true,
  countryProduct: true,
  processingStartDateProduct: true,
  processingEndDateProduct: true,
   processingTypeCodeProduct: true,
   processingDescriptionProduct: true,
}

const APHAVS_NAMEANDCODE_COMPONENT_Fields = {
  categoryCodeComponent: true,
  commonNameComponent: true
}
const APHAVS_COMMODITY_COMPONENT_Fields =  {
  commodityQualCodeComponent: true,
  charDescComponent: true,
  commodityCharQualComponent: true,
}
const APHAVS_SRC_TYPE_QQ_Component_Fields = {
  sourceTypeCodeComponent: true,
  countryComponent: true,
  processingStartDateComponent: true,
  processingEndDateComponent: true,
   processingTypeCodeComponent: true,
   processingDescriptionComponent: true,
}

const AMS_OR2_LPCOTRANSACTION = {
  lcpoTxnType: true,
  lcpoNumber: true,
}
const AMS_OR2_LOTNUMBER = {
  lotNum: true,
  lotNumQualifier: true,
}

const LACEY_ACT_REPEATED = {
  genusName: true,
  speciesName: true,
  countryCode: true,
  indgredientName: true,
  indgredientQuantity: true,
  indgredientUom: true,
  indgredientPercentage: true
}

const PSX_REPEATED_INGREDIENT_Fields = {
  indgredientName: true,
  indgredientPercent: true,
}

const ATFATF_LICENSE_Fields = {
  lcpoNumber: true,
  exemptionCode: true,
  lcpoType: true,
}

const CPSC_PRODUCT_IDENTIFIER_LOOKUP = {
  [CPSC_PRODUCT_IDENTIFIER_FIELDS.ITEM_TYPE]: true,
  [CPSC_PRODUCT_IDENTIFIER_FIELDS.PRODUCT_CODE_NO]: true,
}

const CPSC_ENTITY_ITL_FIELDS = Object.freeze(
  (CPSC_ENTITY_FIELDS.ITL || []).reduce((acc, fieldName) => {
    acc[fieldName] = true
    return acc
  }, {})
)

const CPSC_ENTITY_LAB_FIELDS = Object.freeze(
  (CPSC_ENTITY_FIELDS.LAB || []).reduce((acc, fieldName) => {
    acc[fieldName] = true
    return acc
  }, {})
)

const CPSC_CITATION_ITL_FIELDS = {
  [CPSC_CITATION_FIELDS.ITL]: true,
}

const CPSC_CITATION_LAB_FIELDS = {
  [CPSC_CITATION_FIELDS.LAB]: true,
}

const CPSC_CITATION_NOL_FIELDS = {
  [CPSC_CITATION_FIELDS.NOL]: true,
}

const CPSC_TEST_REPORT_ITL_FIELDS = {
  [CPSC_TEST_REPORT_FIELDS.QUALIFIER_ITL]: true,
  [CPSC_TEST_REPORT_FIELDS.INFORMATION_ITL]: true,
}

const CPSC_TEST_REPORT_LAB_FIELDS = {
  [CPSC_TEST_REPORT_FIELDS.QUALIFIER_LAB]: true,
  [CPSC_TEST_REPORT_FIELDS.INFORMATION_LAB]: true,
}

const repeatedFDAFOOItems = {
  aocQualifier: true,
  aocCode: true,
  packagingQualifier: true,
  quantity: true,
  uom: true,
  ...CPSC_PRODUCT_IDENTIFIER_LOOKUP,
  ...CPSC_ENTITY_ITL_FIELDS,
  ...CPSC_ENTITY_LAB_FIELDS,
  ...CPSC_CITATION_ITL_FIELDS,
  ...CPSC_CITATION_LAB_FIELDS,
  ...CPSC_CITATION_NOL_FIELDS,
  ...CPSC_TEST_REPORT_ITL_FIELDS,
  ...CPSC_TEST_REPORT_LAB_FIELDS,
  ...AMS_OR2_LPCOTRANSACTION,
  ...AMS_OR2_LOTNUMBER,
  ...PSX_REPEATED_INGREDIENT_Fields,
  ...LACEY_ACT_REPEATED,
  ...ATFATF_LICENSE_Fields,
  ...FDAFOO_SOURCE_TYPE_Fields,
  ...APHAVS_NAMEANDCODE_Fields,
  ...APHAVS_COMMODITY_Fields,
  ...REPEATED_PARTIES_PGA_FIELDS,
  ...REPEATED_OMC_AQF_FIELDS,
  ...REPEATED_NMF_370_HARVEST_FIELDS,
  ...REPEATED_NMF_370_BOX5_FIELDS,
  ...REPEATED_NMF_HMS_HARVEST_FIELDS,
  ...REPEATED_NMF_HMS_DOCUMENT_FIELDS,
  ...APHAVS_SRC_TYPE_QQ_Fields,
  ...APHAVS_NAMEANDCODE_COMPONENT_Fields,
  ...DEADEA_CONSTITUENT_Fields,
  ...RepeatedArrivalLocation_Fields,
  ...APHAVS_COMMODITY_COMPONENT_Fields,
  ...APHAVS_SRC_TYPE_QQ_Component_Fields,
  ...EPA_VNE_PRODUCTCOMPONENT_Fields,
  ...FSI_FSI_LOT_LLL_Fields,
  ...APHAVS_NAMEANDCODE_PRODUCT_Fields,
  ...APHAVS_COMMODITY_PRODUCT_Fields,
  ...APHAVS_SRC_TYPE_QQ_Product_Fields,
  constituentElementPercent: true,
  exemptionCode: true,
  constituentElementName: true,
  constituentElementUnitOfMeasure: true,
  constituentElementQuantity: true,
  lotNumQualifier: true,
  lotNum: true,
  productionStartDate: true,
  productionEndDate: true,
  lineValue: true,
  ...SIMPLE_LPCO_VALUES,
  ...APHAVS_COMO_Values,
  ...APHAVS_LPCO_VALUES,
  ...CONFORMANCE_DOC_Fields,
  ...VEHICLE_INFO_Fields,
  ...VEHICLE_VIN_Fields,
  ...ContainerItemFields,
  ...ORRemarks_Values,
  ...COLA_COLA_Fields,
}

// Fields that compose the PGAItem block on Lacey Act
const PGAItemFields = {
  genusName: true,
  speciesName: true,
  countryCode: true,
  indgredientQuantity: true,
  indgredientName: true,
  indgredientUom: true
}

const FDAFOO_AOC_Fields = {
  aocQualifier: true,
  aocCode: true,
}
const FDADRU_LOTNUM_Values = {
  lotNumQualifier: true,
  lotNum: true,
  productionStartDate: true,
  productionEndDate: true,
  lineValue: true,
}

const FDADRU_CONSTITUENT_ELEMENT_Values = {
  constituentElementPercent: true,
  constituentElementName: true,
  constituentElementUnitOfMeasure: true,
  constituentElementQuantity: true
}

const FDAFOO_PQ_Fields = {
  packagingQualifier: true,
  quantity: true,
  uom: true
}

// Takes in a flat HTS (only integers) and inserts '.' as necessary
export const formatCode = code => {
  if (!code) return false
  let res
  if (code.length <= 4) {
    res = code
  } else if (code.length > 4 && code.length <= 6) {
    res = `${code.slice(0, 4)}.${code.slice(4)}`
  } else if (code.length > 6 && code.length <= 8) {
    res = `${code.slice(0, 4)}.${code.slice(4, 6)}.${code.slice(6)}`
  } else if (code.length > 8) {
    res = `${code.slice(0, 4)}.${code.slice(4, 6)}.${code.slice(
      6,
      8
    )}.${code.slice(8)}`
  }
  return res
}

const mapLineItem = (lineItem, index) => {

     let newLineItem = merchandiseLineItem()
        newLineItem.commercialDescription = lineItem.commercialDescription || ''
        newLineItem.categoryCode = lineItem.categoryCode || ''
        newLineItem.productTag = lineItem.productTag || ''
        newLineItem.articleHeader = lineItem.articleHeader || ''
        newLineItem.articleSetId = lineItem.articleSetId || ''
        newLineItem.seqNo = lineItem.seqNo || ''
        newLineItem.articleSubComponent = lineItem.articleSubComponent || []
        newLineItem.manufacturerId = lineItem.manufacturerId || ''
        newLineItem.manufacturerHeaderIdUnderPartiesTab = lineItem.manufacturerHeaderIdUnderPartiesTab || ''
        newLineItem.countryOfOrigin = lineItem.countryOfOrigin || ''
        newLineItem.permitTypeCode = lineItem.permitTypeCode || ''
        newLineItem.permitNumber = lineItem.permitNumber || ''
        newLineItem.pgaProgram = lineItem.pgaProgram || ''
        newLineItem.merchandiseId = lineItem.merchandiseId || 0
        newLineItem.productClaimCode = lineItem.productClaimCode || 'NONE'
        if (newLineItem.productClaimCode === '_BLANK_') {
          newLineItem.productClaimCode = 'NONE' 
        }
        for(let oneline of (lineItem.pgaFlagInfos||[])){
          oneline.formType = oneline.formType || oneline.pgaType;
          oneline.pgaType = oneline.pgaType || oneline.formType;
        }
        newLineItem.pgaFlagInfos = lineItem.pgaFlagInfos || []
        newLineItem.grossWeight.weight = parseFloat(get(lineItem, 'grossWeight.weight', 0)).toFixed(2)
        newLineItem.grossWeight.weightUnits = get(lineItem, 'grossWeight.weightUnits', '_BLANK_')


   



        let newMerchandiseDuties
        if (lineItem.merchandiseDuties) {
          newMerchandiseDuties = []
          lineItem.merchandiseDuties.forEach(duty => {
            let newDuty = {
              hsDataDtl: {
                pgaRuling: [],
                pgaDataLoading:true,
              },
              merchandiseDutyId: duty.merchandiseDutyId || '',
              isCommodityDuty: duty.isCommodityDuty || 2,
              htsus: (duty.htsus) || '',
              isValidHts: true,
              htsDescription: duty.htsDescription || '',
              manifestQuantity: {},
              additionalQuantity: {},
              enteredValue: parseFloat(duty.enteredValue || 0).toFixed(2),
              displayErrorForEnteredValue:[],
              adjustedValue: parseFloat(duty.adjustedValue || 0).toFixed(2),
              duty: parseFloat(duty.duty || 0).toFixed(2),
              otherFee: parseFloat(duty.otherFee || 0).toFixed(2) || 0,
              mpf: {},
              hmf: {},
              IRTax: parseFloat(duty.IRTax || 0).toFixed(2),
              charges: parseFloat(duty.charges || 0).toFixed(2),
              dutyRate: parseFloat(duty.dutyRate || 0).toFixed(2) || '',
              dutyOverrideFlag: duty.dutyOverrideFlag,
              otherRate: parseFloat(duty.otherRate || 0).toFixed(2) || '',
              specificRate: parseFloat(duty.specificRate || 0).toFixed(2) || '',
              additionalDuties: get(duty, 'additionalDuties', {}),
              additions:{},
              deletions:{}
            }
            newDuty.additions.totalAdditions = parseFloat(get(duty, 'additions.totalAdditions', 0)).toFixed(2)
            newDuty.deletions.totalDeletions = parseFloat(get(duty, 'deletions.totalDeletions', 0)).toFixed(2)
            newDuty.manifestQuantity.quantity = parseFloat(get(duty, 'manifestQuantity.quantity', 0)).toFixed(2)
            newDuty.manifestQuantity.units = get(duty, 'manifestQuantity.units', '_BLANK_')
            newDuty.additionalQuantity.quantity = parseFloat(get(duty, 'additionalQuantity.quantity', 0)).toFixed(2)
            newDuty.additionalQuantity.units = get(duty, 'additionalQuantity.units', '_BLANK_')
            newDuty.mpf.fee = parseFloat(get(duty, 'mpf.fee', 0)).toFixed(2)
            newDuty.hmf.fee = parseFloat(get(duty, 'hmf.fee', 0)).toFixed(2)
            newDuty.adcvd = duty.adcvd?JSON.parse(JSON.stringify(duty.adcvd)):{};
            newDuty.additionalDuties.userFees = get(duty, 'additionalDuties.userFees', [])
            newDuty.additionalDuties.userFees.forEach(fee => fee.feeValue = parseFloat(get(fee, 'feeValue', 0)).toFixed(2))

            return newMerchandiseDuties.push(newDuty)
          })
        } else newMerchandiseDuties = [merchandiseDuty()]
         newMerchandiseDuties.sort((aaa,bbb)=>{
          if(aaa.isCommodityDuty != bbb.isCommodityDuty)return aaa.isCommodityDuty-bbb.isCommodityDuty;
          if(ch82SetHtses.includes((aaa.htsus).replaceAll(".","")))return -1;
          if(ch82SetHtses.includes((bbb.htsus).replaceAll(".","")))return 1;
          return 0;
        })

        newLineItem.merchandiseDuties = newMerchandiseDuties
        // If there was not isCommodityDuty set vals with exception so its apparent on UI
        if (
          !newLineItem.merchandiseDuties[0].isCommodityDuty ||
          newLineItem.merchandiseDuties[0].isCommodityDuty === 2
        ) {
          newLineItem.mpf = {
            fee: 'exception'
          }
          newLineItem.hmf = {
            fee: 'exception'
          }
          newLineItem.IRTax = 'exception'
          newLineItem.otherFee = 'exception'
          newLineItem.charges = 'exception'
        }
        return newLineItem
      
}

// Export mapLineItem for use in other modules
export { mapLineItem }